// extracted by mini-css-extract-plugin
export default {"container-documents":"Documents_container-documents__dK7pG","grid":"Documents_grid__KI+sq"};